import React, { Component } from 'react';
import { useContext, useEffect, useState } from "react";
import { Modal, FormControl, InputGroup } from 'react-bootstrap';
import { settingvalidate ,cmsvalidate, validliquiditytoken} from '../../hooks/kycvalidation';
import { updatecmshook } from '../../hooks/usebackend';
import {API_URL} from '../../config/env'
import proof from "../../images/proof.webp"

class Editsettingmodal extends Component {
    constructor(props) {
        
        super(props);
        this.state = {
            editsettingModal: true,
            title:"",
            description:"",
            image: "",
            name: "",
            errors: {}

        };
    }

    componentDidMount() {
        if (!this.state.name && !this.state.image  && !this.state.title && !this.state.description) {
            this.setState({ "title": this.props.data.title });
            this.setState({ "description": this.props.data.description });
            this.setState({ "name": this.props.data.name });
            this.setState({ "image": this.props.data.image })
        }
    }

    
    handleedit = async()=>{
        let payload = {
            id : this.props.data?._id,
            title : this?.state?.title,
            description : this?.state?.description,
            name : this?.state?.name,
            image : this?.state?.image
        }
        console.log("payload",payload);
        let validate = await cmsvalidate(payload);
        console.log(validate,"cmsvalidate")
        if(validate?.isValid){
            let result = await updatecmshook(payload);
            console.log("result",result)
            this.props.onDismiss();
            this.props.getcms()
        }
        else{
            this.setState({"errors" : validate.errors})
        }
    }

    onImageChange = event => {
        if (event.target.files && event.target.files[0]) {
            let img = event.target.files[0];
            this.setState({
                image: img
            });
        }
    };

    render() {


        const { editsettingModal } = this.state


        return (



            <Modal className="wallet-modal" show={editsettingModal} centered size="md">
                <Modal.Header className='pt-3 header_odal_head'>
                    <h3 className="sec-head ">Edit CMS</h3>
                    <button type="button" class="close" onClick={() => this.props.onDismiss()}><span aria-hidden="true">×</span><span class="sr-only">Close</span></button>

                </Modal.Header>
                <Modal.Body className="select-wallet modal_body pt-0 pb-0 px-0">

                    <div className="wallet-lists px-2">

                        <div className='mod_pad_space pt-0'>
                            <div className='row'>
                                <div className='col-12 col-md-12 px-1 mb-3'>

                                </div>
                                {/* <div className='col-12 col-md-12 px-1 mb-3'>
                                    <p className='input_desc_sm'>Setting Name</p>
                                    <div className="inputs input-groups">
                                        <InputGroup className="">
                                            <FormControl id="settingname" placeholder="Setting Name"
                                                aria-describedby="basic-addon2"
                                                value={this.state.settingname}
                                                onChange={(e) => {
                                                    this.setState({ "settingname": e?.target?.value })
                                                }}
                                            />

                                        </InputGroup>
                                        <span className="text-danger f-12 d-block text-left">{this?.state?.errors?.settingvalue}</span>
                                    </div>
                                </div>

                                <div className='col-12 col-md-12 px-1 mb-3'>
                                    <p className='input_desc_sm'>Setting Value</p>
                                    <div className="inputs input-groups">
                                        <InputGroup className="">
                                            <FormControl id="hardcap" value={this?.state?.settingvalue} placeholder="Setting Value"
                                                aria-describedby="basic-addon2"
                                                onChange={(e) => {
                                                    this.setState({ "settingvalue": e?.target?.value })
                                                }}
                                            />

                                        </InputGroup>
                                        <span className="text-danger f-12 d-block text-left">{this?.state?.errors?.settingvalue}</span>
                                    </div>
                                </div> */}


                                <div className="row mb-3 px-3">
                                <div className='col-12 col-sm-12 col-md-12 px-1 mb-3'>
                                    <p className='input_desc_sm'>Title</p> 
                                     <input type='text' className='formcontrol'
                                      name = "title"
                                      value= {this?.state?.title}
                                       onChange={(e) => {
                                        this.setState({ "title": e?.target?.value })
                                      }}  
                                      
                                      />
                                        <span className="text-danger f-12 d-block text-left">{this?.state?.errors?.title}</span>

                                    </div>
                                    <div className='col-12 col-sm-12 col-md-12 px-1 mb-3'>
                                    <p className='input_desc_sm'>Description</p> 
                                     <textarea  rows={5} className='formcontrol'
                                      name = "description"
                                      value= {this?.state?.description}
                                       onChange={(e) => {
                                        this.setState({ "description": e?.target?.value })
                                      }}  
                                     />
                                        <span className="text-danger f-12 d-block text-left">{this?.state?.errors?.description}</span>

                                    </div>
                                    {/* <div className='col-8 col-sm-8 col-md-8 px-1 mb-3'>
                                    <p className='input_desc_sm'>Banner Image</p> 
                                        <div class="browseinput">
                                        <button className="get-started-btn mt-2">
                                        Upload Image
                                    </button>
                                        <input type="file" className='listedimg' name="myImage" onChange={this.onImageChange} />
                                        </div>
                                      

                                    </div> */}
                                    {/* <div className='col-4 col-sm-4 col-md-4 px-1 mb-3'> */}
                                    {/* <div className='col-8 col-sm-8 col-md-8 px-1 mb-3'> */}
                                    {/* <p className='input_desc_sm'>Banner Image</p> */}
                                        {/* <img className='img-fluid bannerimgh' src={typeof this.state.image =='object' ? URL.createObjectURL(this.state.image) : `${API_URL}/public/cms_images/${this.state.image}`} />
                                        <span className="text-danger f-12 d-block text-left">{this?.state?.errors?.image}</span>

                                    </div> */}
                                    
                                </div>
                                


                               

                                <div className='col-12 col-md-12 px-1 text-center'>
                                    <button className="get-started-btn mt-2" onClick={this.handleedit}>
                                        Save
                                    </button>

                                </div>
                            </div>

                        </div>
                    </div>
                </Modal.Body>
            </Modal>



        )
    }

}


export default Editsettingmodal